import { produce } from 'immer'
import { ScreeningStatus } from 'src/models/virtualCard.models'
import { screenVirtualCardRouteProps } from 'src/navigation/routeProps'
import {
  POST_USER_SCREEN_FAILURE,
  POST_USER_SCREEN_INIT,
  POST_USER_SCREEN_SUCCESS,
  PostUserScreenActions,
} from 'src/redux/actions/data/users.actions'
import { createFlyoutReducer } from 'src/redux/genericReducers'
import { ErrorDetailMap, parseBackendErrors } from 'src/utils/error.utils'

export interface ScreenVirtualCardState {
  postingUserScreen: boolean
  postingUserScreenTopLevelError?: string
  postingUserScreenErrorDetailMap?: ErrorDetailMap<string>
  screeningStatus?: ScreeningStatus
}
export const initialState: ScreenVirtualCardState = {
  postingUserScreen: false,
}

export type Actions = PostUserScreenActions

const CoreScreenVirtualCardReducer = (
  state = initialState,
  action: Actions,
): ScreenVirtualCardState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case POST_USER_SCREEN_INIT: {
        draft.postingUserScreen = true
        return draft
      }

      case POST_USER_SCREEN_SUCCESS: {
        draft.postingUserScreen = false
        draft.screeningStatus = action.payload.status
        return draft
      }

      case POST_USER_SCREEN_FAILURE: {
        draft.postingUserScreen = false
        const errors = parseBackendErrors(action.payload)
        draft.postingUserScreenTopLevelError = errors.topLevelError
        draft.postingUserScreenErrorDetailMap = errors.errorDetailMap
        return draft
      }
    }
  })
}

const ScreenVirtualCardReducer = createFlyoutReducer(
  screenVirtualCardRouteProps,
  initialState,
  CoreScreenVirtualCardReducer,
)

export default ScreenVirtualCardReducer
